module.exports = require("./lib/react-router-scroll-top")



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router-scroll-top/index.js
// module id = 680
// module chunks = 0